<template>
  <b-overlay :show="loading" class="animated">
    <v-server-table
      id="prep-workflow-process-server-table"
      :ref="ref"
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      class="w-100"
    >

      <span slot="name" slot-scope="{row}">
        <b-link :to="`/${route_root}/${sample_type_id}/${row.id}`">
          {{ row.name }}
        </b-link>
      </span>

      <span slot="tasks" slot-scope="{row}">
        <b-link :to="`/${route_root}/${sample_type_id}/${row.id}`">
          {{ row.prep_tasks && row.prep_tasks.length || 0 }}
        </b-link>
      </span>

      <span slot="actions" slot-scope="{ row }">
        <b-button v-if="checkPermission('edit prep process')" :to="`/${route_root}/${sample_type_id}/${row.id}/edit`" variant="warning" class="px-1 py-0 text-white mr-1">
          <i class="fa fa-pencil" />
        </b-button>
      </span>

    </v-server-table>
  </b-overlay>
</template>

<script>
import Vue from 'vue'
import { ServerTable } from 'vue-tables-2'
import BaseServerTable from '@/components/shared/BaseServerTable'
import { AccessControlCheck } from '@/auth/AccessControlCheck'
import PrepProcessCollection from '@/collections/lab/PrepProcessCollection'
import { PrepWorkflowRoutes } from '@/router/lab/PrepWorkflowRoutes'

Vue.use(ServerTable)

export default {
  name: 'WorkflowPrepServerTable',
  extends: BaseServerTable,
  props: {
    collection: {
      type: Object,
      default: () => new PrepProcessCollection()
    },
    sample_type_id: {
      type: String,
      default: null
    },
    show_columns: {
      type: Array,
      default: () => [
        'name',
        'tasks',
        'actions'
      ]
    }
  },
  data () {
    return {
      table_config: Object.assign(this.getDefaultTableConfig(), {
        options: {
          headings: {
            name: 'Name',
            actions: 'Actions'
          }
        }
      })
    }
  },
  computed: {
    route_root () {
      return PrepWorkflowRoutes.fetchRoot()
    }
  },
  methods: {
    checkPermission (permission) {
      return AccessControlCheck.checkPermission(permission)
    },

    prepareCollectionFilter(filter) {
      filter.filterEquals('sample_type_id', this.sample_type_id)
    }
  }
}
</script>
